/* eslint-disable react/no-array-index-key */
import * as MUI from "@mui/material";
import {
  APARELHO_ALERTA,
  APARELHO_INFOPOL,
  DADOS_INFOPOL,
} from "../../interface/celular";
import { LabelInfo } from "../ConsultasIntegrada";

interface FichaCelularProps {
  aparelhoAlerta?: APARELHO_ALERTA;
  aparelhoInfopol?: APARELHO_INFOPOL;
  dadosInfopol?: DADOS_INFOPOL;
}

const styleInputs = {
  display: "flex",
  flexDirection: "row",
  gap: 1,
};

export const InfoCelular: React.FC<FichaCelularProps> = ({
  aparelhoAlerta,
  aparelhoInfopol,
  dadosInfopol,
}) => {
  if (aparelhoAlerta) {
    return (
      <>
        <MUI.Typography variant="body1" fontWeight="bold">
          Informações do aparelho no Sistema Alerta Celular
        </MUI.Typography>

        <MUI.Grid container>
          {aparelhoAlerta.SITUACAO !== "NÃO ALERTADO" &&
          aparelhoAlerta.DATAALERTA ? (
            <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
              <LabelInfo label="Data Alerta" info={aparelhoAlerta.DATAALERTA} />
            </MUI.Grid>
          ) : (
            false
          )}

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="Imei:" info={aparelhoAlerta.IMEI} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="Serial:" info={aparelhoAlerta.SERIAL} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="Marca:" info={aparelhoAlerta.MARCA} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="Modelo:" info={aparelhoAlerta.MODELO} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo
              label="Proprietário:"
              info={aparelhoAlerta.PROPRIETARIO}
            />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="RG:" info={aparelhoAlerta.RG} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="CPF:" info={aparelhoAlerta.CPF} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="Email:" info={aparelhoAlerta.EMAIL} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="Número:" info={aparelhoAlerta.NUMERO} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="Nome da mãe:" info={aparelhoAlerta.NOME_MAE} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="Nome do pai:" info={aparelhoAlerta.NOME_PAI} />
          </MUI.Grid>

          <MUI.Grid xs={12} md={12} sm={12} item sx={styleInputs}>
            <MUI.Typography fontWeight="bold" variant="body1">
              Contatos:
            </MUI.Typography>
            {aparelhoAlerta.CONTATOS &&
              aparelhoAlerta.CONTATOS.map((contato, index: number) => (
                <MUI.Typography variant="body1" key={index}>
                  {contato.NOME} -{" "}
                  {contato.TELEFONE ? contato.TELEFONE : "s/número"} /
                </MUI.Typography>
              ))}
          </MUI.Grid>
        </MUI.Grid>
        <MUI.Divider />
      </>
    );
  }

  if (aparelhoInfopol) {
    return (
      <>
        <MUI.Typography variant="body1" fontWeight="bold">
          Informações do aparelho no Sistema INFOPOL
        </MUI.Typography>

        <MUI.Grid container>
          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo
              label="Imei:"
              info={aparelhoInfopol.IMEIS.join(" // ")}
            />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="Marca:" info={aparelhoInfopol.MARCA} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="Modelo:" info={aparelhoInfopol.MODELO} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo
              label="Proprietário:"
              info={aparelhoInfopol.PROPRIETARIO}
            />
          </MUI.Grid>
        </MUI.Grid>
        <MUI.Divider />
      </>
    );
  }

  if (dadosInfopol) {
    return (
      <>
        <MUI.Typography variant="body1" fontWeight="bold">
          Informações do BOE
        </MUI.Typography>

        <MUI.Grid container>
          <MUI.Grid xs={12} md={12} sm={12} item sx={styleInputs}>
            <MUI.Typography fontWeight="bold" variant="body1">
              Boletins:
            </MUI.Typography>
            <MUI.Typography variant="body1" color="#005F98" fontWeight="bold">
              {dadosInfopol.NUMERO_BO.join(" // ")}
            </MUI.Typography>
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo
              label="Natureza:"
              info={dadosInfopol.NM_NATUREZA_OCORRENCIA}
            />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label=" Data do fato:" info={dadosInfopol.DATA_FATO} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo
              label="Logradouro do fato:"
              info={dadosInfopol.NM_LOGRADOURO}
            />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo label="Bairro do fato:" info={dadosInfopol.NM_BAIRRO} />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <LabelInfo
              label="Municipio do fato:"
              info={dadosInfopol.NM_MUNICIPIO}
            />
          </MUI.Grid>

          <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
            <MUI.Typography fontWeight="bold" variant="body1">
              Em posse de:
            </MUI.Typography>
            <MUI.Typography variant="body1">
              {dadosInfopol.NOME_PESSOA} (
              {dadosInfopol.NM_TIPO_ENVOLVIMENTO_PESSOA})
            </MUI.Typography>
          </MUI.Grid>
        </MUI.Grid>

        <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
          <LabelInfo label="Da mãe:" info={dadosInfopol.NOME_MAE} />
        </MUI.Grid>

        <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
          <LabelInfo label="Do pai:" info={dadosInfopol.NOME_PAI} />
        </MUI.Grid>

        <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
          <LabelInfo
            label="Unidade Operacional:"
            info={dadosInfopol.NM_UNIDADE_OPERACIONAL}
          />
        </MUI.Grid>
        <MUI.Grid xs={12} sm={6} md={4} item>
          <LabelInfo
            label="Histórico da ocorrência:"
            info={dadosInfopol.DS_HISTORICO}
          />
        </MUI.Grid>
      </>
    );
  }

  return null;
};
